export const equipmentTypeLabelList = {
  sensor: 'Equipment Name / Sensor',
  mote: 'Equipment Name / Sensor',
  node: 'Node Serial Number',
  router: 'Repeater Serial Number',
  gateway: 'Gateway Serial Number',
};
